import { useFlag } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFetchContactQuery } from 'features/contacts/api';
import { useMeetingIntelligenceFeatureFlag } from 'hooks/meeting_intelligence_awareness';
import { EmptyMeetingHistory } from './empty_meeting_history';
import { NextMeetingHistory } from './next_meeting';
import { PastMeetingHistory } from './past_meeting_history';
import { historyPush } from '../../../actions/core/navigation';
const sectionHeaderCss = "sho2v2p";
const SectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const containerCss = "c1iqpf0g";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const RenderNoMeetingHistory = () => <>
    <Container>
      <SectionHeader>
        <BodyText size="medium" color="muted" weight="bold">{I18n.t('publisher.contacts.profile.meetings')}</BodyText>
      </SectionHeader>
    </Container>
    <EmptyMeetingHistory />
  </>;
export const MeetingHistorySection = ({
  uuid,
  email
}) => {
  const dispatch = useDispatch();
  const {
    data: contact,
    isLoading
  } = useFetchContactQuery({
    uuid,
    email
  });
  const isMIEnabled = useMeetingIntelligenceFeatureFlag();
  const hasNewMeetingsPage = useFlag('sa_new_meetings_page', false);
  const isNewMeetingsPageEnabled = isMIEnabled || hasNewMeetingsPage;
  const createViewClickHandler = period => () => {
    const path = isNewMeetingsPageEnabled ? `/app/meetings/user/me?invitee_emails[]=${encodeURIComponent(email)}` : `/app/scheduled_events/user/me?period=${period}&invitee_emails[]=${encodeURIComponent(email)}`;
    dispatch(historyPush(path));
  };
  const handleViewPastClick = createViewClickHandler('past');
  const handleViewUpcomingClick = createViewClickHandler('upcoming');
  return <>

      {isLoading && <Loader />}
      {contact != null && contact.lastEvent.length < 1 && contact.nextEvent.length < 1 && <RenderNoMeetingHistory />}
      {contact != null && (contact.lastEvent.length >= 1 || contact.nextEvent.length >= 1) && <Container>
            <NextMeetingHistory nextMeeting={contact?.nextEvent?.[0]} onHandleClick={handleViewUpcomingClick} />
            <PastMeetingHistory pastMeetings={contact?.lastEvent} onShowAll={handleViewPastClick} />
          </Container>}
    </>;
};

require("./meeting_history_section.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_history_section.js");